import { ViewModel, View } from "binder"
import { LastTenSalesView } from "./lastTenSales-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { FileChooser } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile } from "src/uicomponents/components/utilities";

export class LastTenSalesViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'گزارش 10 فروش آخر';
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set fileContent(v: string) { this._fileContent = v; } public get fileContent(): string { return this._fileContent; } private _fileContent: string;
    public set fileName(v: string) { this._fileName = v; } public get fileName(): string { return this._fileName; } private _fileName: string;
    public set hasGenAndMobBrand(v: boolean) { this._hasGenAndMobBrand = v; } public get hasGenAndMobBrand(): boolean { return this._hasGenAndMobBrand;} private _hasGenAndMobBrand: boolean;
    public set fileChoosed(v: boolean) { this._fileChoosed = v; } public get fileChoosed(): boolean { return this._fileChoosed;} private _fileChoosed: boolean;
    


    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View<ViewModel> {
        return new LastTenSalesView();
    }
    public getTypeId(): string {
        return "VM-AA665C10-BAE7-4AF4-9145-3306B318A604"
    }

    async chooseFile() {
        let choosedFile = await new FileChooser().chooseFile();
        if(choosedFile.isChoosed){
            this.fileName = choosedFile.filename;
            this.fileContent = choosedFile.fileContent;
            this.fileChoosed = true;
        }
    }

    async downloadFile() {
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer("/Complex/ReportServices/LastTenSales",{
                ExcelFile : this.fileContent,
                HasGenAndMobBrand : this.hasGenAndMobBrand
            });
            downloadFile(serverResult.ExcelFile,'گزارش 10 فروش آخر.xlsx');
            if(serverResult.IsSuccessful == true){
                await this.messageBoxConfirmSuccess("گزارش با موفقیت دانلود شد.","گزارش 10 فروش آخر");
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export class singleFile extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.isShowing = false;
    }

    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set path(v: string) { this._path = v; } public get path(): string { return this._path; } private _path: string;
    public set isShowing(v: boolean) { this._isShowing = v; } public get isShowing(): boolean { return this._isShowing; } private _isShowing: boolean;

    public set showingPath(v: string) { this._showingPath = v; } public get showingPath(): string { return this._showingPath; } private _showingPath: string;

}
